import viewportObserver from "./components/viewportObserver";

import './blocks/announcement-bar/frontend';
import './blocks/google-map/frontend';
import './blocks/hero/frontend';
import './blocks/slideshow/frontend';
import './blocks/media/frontend';
import "./blocks/openhours/hoursparser";

import "./components/advanced-gallery/frontend";

